import SocialIcons from './SocialIcons'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <p className="copyright copyright-text">designed by nessa kodo © 2026</p>
        <nav className="footer-nav" aria-label="Footer navigation">
          <Link to="/" className="footer-nav-link">home</Link>
          <Link to="/about" className="footer-nav-link">about</Link>
          <Link to="/sessions" className="footer-nav-link">sessions</Link>
          <Link to="/library" className="footer-nav-link">library</Link>
        </nav>
        <div className="footer-icons">
          <SocialIcons />
        </div>
      </div>
    </footer>
  )
}

export default Footer
